
// @flow
import moment from 'moment-timezone';

import { type Params, dateFormat } from 'app/dataTypes/OrgMenuAddRemove.types';

import type { Request } from '../../index';


const dateFormatApi: 'YYYY-MM-DD' = 'YYYY-MM-DD';

type ParamsApi = {
  school_id: number,
  sale_point_id: number, // точка продаж
  date: string,
  add_dishes: Array<number>, // id добавляемых блюд
  remove_dishes: Array<number>, // id удаляемых блюд
}

type Result = 'success'

export const convertParams = (params: Params): [ParamsApi, null] => {
  const { orgId, sellPointId, date, add, remove } = params;

  return [{
    school_id: orgId,
    sale_point_id: sellPointId,
    date: moment(date, dateFormat).format(dateFormatApi),
    add_dishes: add,
    remove_dishes: remove,
  }, null];
};

export const POST_ITEMS_ADD_REMOVE: Request<
  Params,
  Result,
  void
> = [
  'food/menu/menu_items_add_remove',
  'post',
  ['data', 'result'],
];
